var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTruckSmall = function SvgTruckSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#truck-small_svg__a)",
    stroke: props.fill,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 2.5H.833v10.833h12.5V2.5ZM13.333 6.666h3.333l2.5 2.5v4.167h-5.833V6.666ZM4.583 17.5a2.083 2.083 0 1 0 0-4.166 2.083 2.083 0 0 0 0 4.167ZM15.416 17.5a2.083 2.083 0 1 0 0-4.166 2.083 2.083 0 0 0 0 4.167Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "truck-small_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgTruckSmall;